import React, { useEffect, useState } from 'react'

const Snackbar = () => {
  const [queue, setQueue] = useState([])

  useEffect(() => {
    const handler = (e) => {
      const detail = e.detail || {}
      setQueue((q) => [...q, { id: Date.now(), ...detail }])
    }
    window.addEventListener('app:notify', handler)
    return () => window.removeEventListener('app:notify', handler)
  }, [])

  useEffect(() => {
    if (queue.length === 0) return
    const t = setTimeout(() => {
      setQueue((q) => q.slice(1))
    }, 3000)
    return () => clearTimeout(t)
  }, [queue])

  if (queue.length === 0) return null
  const current = queue[0]
  const bg = current.type === 'error' ? 'bg-red-600' : current.type === 'warning' ? 'bg-yellow-600' : 'bg-green-600'

  return (
    <div className="fixed bottom-6 right-6 z-[1000]">
      <div className={`${bg} text-white px-4 py-3 rounded shadow-lg min-w-[240px]`}>{current.message}</div>
    </div>
  )
}

export default Snackbar


